<template>
  <div class="w-[100%] mx-auto p-4">
    <div class=" bg-white p-4 rounded-lg">


      <div class="mt-2 flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4 h-8">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
          سود واحد نرم افزار
      </span>

        <div class="flex flex-wrap gap-2">
          <select v-model="filters.quick_date_filter"
                  class="px-3 py-2 bg-gray-100 text-sm rounded-lg border text-right">
            <option value="all" @click="resetFilters"> همه</option>
            <option v-for="(label, key) in quickDateLAbles" :key="key" :value="key" @click="handleQuickDate(key)">
              {{ label }}
            </option>
          </select>

          <date placeholder="از تاریخ" v-model="filters.start_date" @input="fetchOrders(1)"></date>
          <date placeholder="تا تاریخ" v-model="filters.end_date" @input="fetchOrders(1)"></date>
        </div>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg p-2 mb-3 mt-1">
      <div class="grid grid-cols-2 md:grid-cols-5 gap-3 h-16">
        <div class="bg-blue-50 p-3 rounded-lg border border-blue-100 hover:shadow-md transition-shadow h-16">
          <div class="flex items-start ">
            <div class="bg-blue-100 p-2 rounded-full mr-1 ml-3 ">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
            </div>
            <div class="mt-1">
              <span class="text-[8px] text-gray-500">تعداد کل سفارش ها : </span>
              <span class="text-xs font-medium text-gray-800  ml-2">
                 {{ summary.total_order_count | toMoney }}
                <span class="text-[7px] text-gray-500">عدد</span>
              </span>

            </div>
          </div>
        </div>

        <div class="bg-yellow-50 p-3 rounded-lg border border-yellow-100 hover:shadow-md transition-shadow h-16 mb-1">
          <div class="flex items-start">
            <div class="bg-amber-100 p-2 rounded-full mr-1 ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-600" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div class="mt-1">
              <span class="text-[8px] text-gray-500">جمع غیر ایرانی : </span>
              <span class="text-xs font-medium text-gray-800  ml-2">
                {{ summary.total_price | toMoney }}
                <span class="text-[7px] text-gray-500">تومان</span>
              </span>

            </div>
          </div>
        </div>

        <div class="bg-purple-50 p-3 rounded-lg border border-purple-100 hover:shadow-md transition-shadow h-16 mb-1">
          <div class="flex items-start">
            <div class="bg-purple-100 p-2 rounded-full mr-2 ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"/>
              </svg>
            </div>
            <div class="mt-1">
              <span class="text-[8px] text-gray-500">سهم 3 درصد : </span>
              <span class="text-xs font-medium text-gray-800  ml-2">
                {{ (summary.total_price / 100 * 3) | toMoney }}
                <span class="text-[7px] text-gray-500">تومان</span>
              </span>

            </div>
          </div>
        </div>

        <div class="bg-green-50 p-3 rounded-lg border border-green-100 hover:shadow-md transition-shadow h-16 mb-1">
          <div class="flex items-start">
            <div class="bg-green-100 p-2 rounded-full mr-2 ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div class="mt-1">
              <span class="text-[8px] text-gray-500">پرداختی : </span>
              <span class="text-xs font-medium text-gray-800  ml-2">
                0
                <span class="text-[7px] text-gray-500">تومان</span>
              </span>

            </div>
          </div>
        </div>
        <div class="bg-red-100 p-3 rounded-lg border border-red-200 hover:shadow-md transition-shadow h-16 mb-1">
          <div class="flex items-start">
            <div class="bg-red-200 p-2 rounded-full mr-2 ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-500" width="24" height="24"
                   viewBox="0 0 24 24" stroke-width="2" stroke="#dc2626" fill="none" stroke-linecap="round"
                   stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M12 9v2m0 4v.01"/>
                <path
                    d="M10.29 3.86l-7.06 12.21a2 2 0 0 0 1.72 3.01h14.1a2 2 0 0 0 1.72-3.01l-7.06-12.21a2 2 0 0 0-3.42 0z"/>
              </svg>

            </div>
            <div class="mt-1">
              <span class="text-[8px] text-gray-500">پرداخت نشده : </span>
              <span class="text-xs font-medium text-gray-800  ml-2">
                {{ ((summary.total_price / 100 * 3) - 0) | toMoney }}
                <span class="text-[7px] text-gray-500">تومان</span>
              </span>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg overflow-hidden">
      <div v-if="loading" class="p-8 text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
        <p class="mt-2">Loading data...</p>
      </div>

      <div v-else-if="orders.length === 0" class="p-8 text-center text-gray-500">
        <p>سفارشی موجود نیست</p>
      </div>

      <div v-else>
        <div v-for="(orderData, index) in orders" :key="index" class="border-b border-gray-200 cursor-pointer"
             @click="toggleOrder(orderData.order.id)">
          <div class="p-4 hover:bg-gray-50">
            <div
                class="flex justify-between items-start "

            >
              <h3 class="font-medium">
                <button
                    @click="$router.push(`/panel/adminOrderDetail/${orderData.order.id}`)"
                    type="button"
                    class="p-1 rounded-full bg-blue-200 hover:bg-blue-400 text-blue-800 shadow transition duration-200"
                >
                  <svg xmlns="http://www.w3.org/2000/svg"
                       fill="none" viewBox="0 0 24 24"
                       stroke-width="1" stroke="blue"
                       class="w-3 h-3">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 12s3.75-6.75 9.75-6.75 9.75 6.75 9.75 6.75-3.75 6.75-9.75 6.75S2.25 12 2.25 12z"/>
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </button>


                سفارش #{{ orderData.order.id }}
                <span class="text-[10px] text-gray-700 mr-3">
                    اکسونی کد #{{ orderData.order.exuni_tracking_code }}</span>
              </h3>
              <span class="text-[9px] text-gray-500">
                  {{ orderData.order.date_time | toJDate }}
                  {{ orderData.order.payment_display }}
                </span>
              <span class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-[11px]">
              جمعا
              {{ orderData.order.amount_sum | toMoney }} تومان کالای غیر ایرانی
            </span>
            </div>

            <div
                v-show="isOrderOpen(orderData.order.id)"
                class="mt-4 overflow-hidden transition-all duration-300 ease-in-out"
                :class="{
            'max-h-0': !isOrderOpen(orderData.order.id),
            'max-h-screen': isOrderOpen(orderData.order.id)
          }"
            >
              <div v-for="(item, itemIndex) in orderData.items" :key="itemIndex"
                   class="pl-4 py-2 border-l-2 border-gray-200">
                <div class="flex justify-between">
                  <div>
                    <div class="flex items-center gap-3">
                      <div class="relative" v-if="item.product.image">
                        <img
                            :src="img_source(item.product.image)"
                            class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                        >
                      </div>
                      <div>
                        <div class="text-[9px] font-medium text-gray-900">{{ item.product.name }}</div>
                        <div class="text-[9px] text-gray-500 text-xs mt-1 flex items-center gap-1"
                             v-if="item.product.product_type == 'variation'">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                               stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                          </svg>
                          {{ item.product.variation_of_name }}
                        </div>
                      </div>
                    </div>
                    <span class="text-[10px] text-blue-500">
                      {{ item.product_quantity | toMoney }} عدد × {{ item.price | toMoney }} تومان
                    </span>

                  </div>


                  <span class="text-gray-700">
                {{ (item.price * item.product_quantity)  | toMoney }}تومان

              </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg p-2 mb-3 mt-1">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 h-8">
        <div class="bg-blue-500  rounded-lg border border-blue-400 hover:shadow-md transition-shadow h-8">
          <div class="flex items-start ">
            <div>
              <span class="text-[8px] text-white mr-2">تعداد سفارش ها در صفحه : </span>
              <span class="text-xs font-medium text-white  ml-2">
                 {{ pagination_summary.total_order_count | toMoney }}
                <span class="text-[7px] text-white">عدد</span>
              </span>

            </div>
          </div>
        </div>

        <div class="bg-yellow-500  rounded-lg border border-yellow-400 hover:shadow-md transition-shadow h-8">
          <div class="flex items-start">
            <div>
              <span class="text-[8px] text-white mr-2"> غیر ایرانی در صفحه : </span>
              <span class="text-xs font-medium text-white  ml-2">
                {{ pagination_summary.total_price | toMoney }}
                <span class="text-[7px] text-white">تومان</span>
              </span>

            </div>
          </div>
        </div>

        <div class="bg-purple-500  rounded-lg border border-purple-400 hover:shadow-md transition-shadow h-8 ">
          <div class="flex items-start">
            <div>
              <span class="text-[8px] text-white mr-2">سهم 3 درصد در صفحه: </span>
              <span class="text-xs font-medium text-white  ml-2">
                {{ (pagination_summary.total_price / 100 * 3) | toMoney }}
                <span class="text-[7px] text-white">تومان</span>
              </span>

            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="flex items-center justify-between mt-4 space-x-2 ">
      <div class="flex items-center gap-1">
        <label class="text-sm text-white bg-primary rounded pa-1">فاکتور در هر صفحه:</label>
        <select v-model="perPage"
                @change="fetchOrders(1)"
                class="text-sm border rounded p-1  text-blue-100 bg-blue-700 hover:bg-gray-900 cursor-pointer">
          <option :value="15">15</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>

      <div class="flex gap-1">
        <button
            @click="prevPage"
            :disabled="currentPage === 1"
            class="text-sm border rounded p-1 text-blue-100 bg-blue-700 hover:bg-gray-900 cursor-pointer disabled:opacity-50"
        >
          صفحه قبل
        </button>
        <span class=" px-2 py-1 text-sm text-white bg-primary rounded pa-1">صفحه {{ currentPage }}</span>
        <button
            @click="nextPage"
            :disabled="(currentPage * perPage) >= totalCount"
            class="text-sm border rounded p-1 text-blue-100 bg-blue-700 hover:bg-gray-900 cursor-pointer disabled:opacity-50"
        >
          صفحه بعد
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment-jalaali";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      totalCount: 0,
      loading: false,
      orders: [],
      openOrders: [],
      summary: {
        total_order_count: 0,
        total_price: 0
      },
      pagination_summary: {
        total_order_count: 0,
        total_price: 0
      },
      quickDateLAbles: {
        today: "امروز",
        yesterday: "دیروز",
        this_month: "این ماه",
      },
      filters: {
        from_date: '',
        to_date: '',
        start_date: '',
        end_date: '',
        quick_date_filter: 'all'
      },
    }
  },
  methods: {
    resetFilters() {
      this.filters = {
        from_date: '',
        to_date: '',
        start_date: '',
        end_date: '',
        quick_date_filter: 'all'
      }
      this.fetchOrders(1)
    },
    handleQuickDate(key) {
      this.filters.start_date = ''
      this.filters.end_date = ''
      let from, to;

      if (key === 'today') {
        const today = moment();
        from = to = today;
      } else if (key === 'yesterday') {
        const yesterday = moment().subtract(1, 'day');
        from = to = yesterday;
      } else if (key === 'this_month') {
        from = moment().startOf('jMonth');
        to = moment().endOf('jMonth');
      }

      this.filters.from_date = from.format('YYYY-MM-DD');
      this.filters.to_date = to.format('YYYY-MM-DD');

      this.fetchOrders(1);
    },
    nextPage() {
      if ((this.currentPage * this.perPage) < this.totalCount) {
        this.fetchOrders(this.currentPage + 1)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.fetchOrders(this.currentPage - 1)
      }
    },

    toggleOrder(orderId) {
      const index = this.openOrders.indexOf(orderId);
      if (index === -1) {
        this.openOrders.push(orderId);
      } else {
        this.openOrders.splice(index, 1);
      }
    },
    isOrderOpen(orderId) {
      return this.openOrders.includes(orderId);
    },

    fetchOrders(page = 1) {
      const offset = (page - 1) * this.perPage
      const params = {
        limit: this.perPage,
        offset: offset || 0,
      }
      if (this.filters.from_date) params.from_date = this.filters.from_date
      if (this.filters.to_date) params.to_date = this.filters.to_date
      if (this.filters.start_date) params.start_date = this.filters.start_date
      if (this.filters.end_date) params.end_date = this.filters.end_date
      this.request({
        url: this.endpoint(`finance/softwareDevelopmentProfit`),
        params: params,
        method: 'get',
        success: (response) => {
          this.orders = response.orders
          this.summary = response.summary
          this.pagination_summary = response.pagination_summary
          this.totalCount = response.count
          this.currentPage = page

        },
      })
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
  },
  mounted() {
    this.fetchOrders(1)
  }
}
</script>